<template>
  <div class="cmp-sidebar-layout">
    <div class="content">
      <div class="cmp-sidebar-layout-inner transition-all">
        <slot></slot>
      </div>
    </div>

    <div class="side" data-v-sticky-container>
      <div ref="side" v-sticky="stickyOptions" tabindex="0">
        <slot name="side" data-v-sticky-inner></slot>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import { dom } from 'quasar';

import { Subscription, fromEvent } from 'rxjs';
import { throttle, debounceTime } from 'rxjs/operators';

const { height } = dom;

import VueStickyDirective from '@/vendor/vue-sticky-directive/vueSticky.directive';

@Component({
  directives: {
    sticky: VueStickyDirective,
  },
})
class SidebarLayout extends Vue {
  readonly mobile!: boolean;

  stickyOptions = {
    topSpacing: this.getTopSpacing(),
    bottomSpacing: 16,
    // resizeSensor has to be disabled because it causes overflowing in some cases probably of bugs from
    // forked vue-sticky-directive. Resizing window can cause bug with calculating top/bottom borders, but
    // it wasn't happening during testing.
    resizeSensor: false,
    containerSelector: '[data-v-sticky-container]',
    innerWrapperSelector: '[data-v-sticky-inner]',
    disabled: this.mobile,
  };

  resizeEvent: Subscription | null = null;

  created() {
    window.addEventListener('scroll', this.handleScroll);
  }
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll() {
    this.stickyOptions.topSpacing = this.getTopSpacing();
  }

  resizeHook() {
    const stream = fromEvent(window, 'resize');
    const controllerStream = stream.pipe(debounceTime(500));
    this.resizeEvent = stream
      .pipe(
        throttle(() => controllerStream, {
          leading: true,
          trailing: true,
        })
      )
      .subscribe(() => {
        this.stickyOptions.disabled = this.mobile;
      });
  }

  destroySticky() {
    if (this.resizeEvent) {
      this.resizeEvent.unsubscribe();
    }
  }

  getTopSpacing() {
    const fullHeader = document.querySelector('.sticky-header-wrap');

    let spacing = 0;
    spacing += fullHeader ? height(fullHeader) + 24 : 0;

    return spacing;
  }
}

export default SidebarLayout;
</script>

<style lang="scss" scoped>
.cmp-sidebar-layout {
  width: 100%;
  display: grid;
  grid-template-columns: auto minmax(250px, 363px);
  grid-template-areas: 'content side';
  column-gap: map-get($space-4xl, x);

  > .content {
    grid-area: content;
    z-index: 2;
    min-width: 394px;
  }

  > .side {
    grid-area: side;
    z-index: 1;
  }

  @media (max-width: $ws-breakpoint-tablet-max) {
    column-gap: map-get($space-md, x);
  }

  @media (max-width: $ws-breakpoint-mobile-max) {
    display: block;

    > .content {
      width: 100%;
      min-width: auto;
    }
    > .side {
      margin-top: map-get($space-xl, y);
      width: 100%;
    }
  }
}
</style>
